import { AuthTokenStorage } from "../auth/AuthTokenStorage";
import { OpenAPI } from "./service";

OpenAPI.TOKEN = async () => AuthTokenStorage.get() || "";
OpenAPI.WITH_CREDENTIALS = true;
// In production both www.miactivo.com and app.miactivo.com proxy /api/ to the
// same backend, so use relative URLs to avoid cross-origin requests.
// In development the backend runs on a different port, so keep the absolute URL.
OpenAPI.BASE = process.env.NODE_ENV === "production"
    ? ""
    : ((process.env.REACT_APP_BACKEND_URL || process.env.BACKEND_URL) as string);
OpenAPI.CREDENTIALS = "omit";
